import { Component } from '@angular/core';

@Component({
  selector: 'app-card-inmueble',
  standalone: false,
  templateUrl: './card-inmueble.component.html',
  styleUrl: './card-inmueble.component.scss'
})
export class CardInmuebleComponent {

}
